import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ItemCardHeader } from '@backstage/core-components';
import { FavoriteEntity } from '@backstage/plugin-catalog-react';

const useStyles = makeStyles(() => ({
  header: {
    backgroundImage: ({ cardBackgroundImage }) => cardBackgroundImage,
    color: ({ cardFontColor }) => cardFontColor
  },
  subtitleWrapper: {
    display: "flex",
    justifyContent: "space-between"
  }
}));
const CardHeader = (props) => {
  const {
    template: {
      metadata: { title, name },
      spec: { type }
    }
  } = props;
  const { getPageTheme } = useTheme();
  const themeForType = getPageTheme({ themeId: type });
  const styles = useStyles({
    cardFontColor: themeForType.fontColor,
    cardBackgroundImage: themeForType.backgroundImage
  });
  const SubtitleComponent = /* @__PURE__ */ React.createElement("div", { className: styles.subtitleWrapper }, /* @__PURE__ */ React.createElement("div", null, type), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FavoriteEntity, { entity: props.template, style: { padding: 0 } })));
  return /* @__PURE__ */ React.createElement(
    ItemCardHeader,
    {
      title: title ?? name,
      subtitle: SubtitleComponent,
      classes: { root: styles.header }
    }
  );
};

export { CardHeader };
//# sourceMappingURL=CardHeader.esm.js.map
